import { WorkforceMovementsEnum } from '../../../types'

export const countIntegerDigits = (n: number): number => String(Math.trunc(Math.abs(n))).length

type CounterRow = {
  workforceMovementType: WorkforceMovementsEnum
  currentMonth: number
  nextMonth?: number | null
  previousMonth?: number | null
}

type PickedCounter = {
  currentMonth: number
  nextMonth: number
  previousMonth: number
}

const pickCounter = (rows: CounterRow[] | undefined, type: WorkforceMovementsEnum): PickedCounter => {
  const r = rows?.find((x) => x.workforceMovementType === type)
  return {
    currentMonth: r?.currentMonth ?? 0,
    nextMonth: r?.nextMonth ?? 0,
    previousMonth: r?.previousMonth ?? 0,
  }
}

export type HeaderCountersDisplay = {
  totalEmployees: number
  newEntries: { main: number; previousMonth: number; currentMonth: number }
  employeeExits: { main: number; currentMonth: number; nextMonth: number }
  probationEnd: { main: number; currentMonth: number; nextMonth: number }
}

export const buildHeaderCountersFromDto = (
  rows: CounterRow[] | undefined,
  totalEmployees: number,
): HeaderCountersDisplay => {
  const newEntries = pickCounter(rows, WorkforceMovementsEnum.NewEntries)
  const leavers = pickCounter(rows, WorkforceMovementsEnum.Leavers)
  const probation = pickCounter(rows, WorkforceMovementsEnum.ProbationPeriodEnding)

  return {
    totalEmployees,
    newEntries: {
      main: newEntries.previousMonth + newEntries.currentMonth,
      previousMonth: newEntries.previousMonth,
      currentMonth: newEntries.currentMonth,
    },
    employeeExits: {
      main: leavers.currentMonth + leavers.nextMonth,
      currentMonth: leavers.currentMonth,
      nextMonth: leavers.nextMonth,
    },
    probationEnd: {
      main: probation.currentMonth + probation.nextMonth,
      currentMonth: probation.currentMonth,
      nextMonth: probation.nextMonth,
    },
  }
}
